import { FC, createElement } from 'react';
import cn from 'classnames';

import { generateValidationParams } from '@/utils/generateValidationParams';

import { InputProps } from './Input.props';

export const Input: FC<InputProps> = ({
  className,
  register,
  required,
  type = 'text',
  name = '',
  locale = 'UA',
  ...rest
}: InputProps) => {
  const inputProps = {
    ...register(
      name,
      generateValidationParams({ type, name, required, locale }),
    ),
    noValidate: type == 'email' ? true : false,
    type,
    className: cn(
      'focus:box-shadow-none relative w-full border-b border-l-0 border-r-0 border-t-0 border-b-accentMain bg-transparent py-5 pl-[72px] text-md text-textPrimary placeholder:text-primaryMiddle focus:border-accentMain focus:ring-transparent dark:text-white dark:placeholder-darkGrayPM',
      className,
      {
        'resize-none': type == 'textarea',
      },
    ),
    ...rest,
    ...(type == 'textarea' && { rows: 3 }),
  };

  return (
    <>{createElement(type == 'textarea' ? 'textarea' : 'input', inputProps)}</>
  );
};
